import { call, put } from "redux-saga/effects";
import moment from "moment";
import Cookies from "universal-cookie";
import { resolvePromiseAction, rejectPromiseAction } from "@adobe/redux-saga-promise";

import Api from "common/api";
import constants from "./constants";
import _get from "lodash/get";
import contactSaga from "../contact/sagas";

const AuthWithRMPToken = function* (data) {
  const __name = constants.AUTH_WITH_RMP_TOKEN;
  try {
    const otp = data.token;
    console.log("auth with rmp token");
    const res = yield call(Api.AuthWithRMPToken, otp);
    console.log(res);
    yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    return { res };
  } catch (err) {
    err.result = 1;
    console.log(err);
    yield put({ type: `FETCH_FAILURE_${__name}`, err });
    return { err };
  }
};

const AuthWithRMPOtp = function* (data) {
  const __name = constants.AUTH_WITH_RMP_OTP;
  try {
    const otp = data.otp;
    const res = yield call(Api.AuthWithRMPOtp, otp);
    console.log("res", res);
    yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
    return { res };
  } catch (err) {
    err.result = 1;
    console.log(err);
    yield put({ type: `FETCH_FAILURE_${__name}`, err });
    return { err };
  }
};

const setAd = function* (data) {
  const __name = constants.AD;
  const rmp_token = sessionStorage.getItem("rmp_token");
  yield put({ type: `FETCH_SUCCESS_${__name}`, data: data.ad });

  if (data.managedService === "Y") {
    yield call(contactSaga.GetContactInfo, { token: rmp_token, adAccountId: data.ad.ads_account_id });
  }
};

const setFacebookAd = function* (data) {
  const __name = constants.FACEBOOK_AD;
  yield put({ type: `FETCH_SUCCESS_${__name}`, data: data.ad });
};

const setupAuthData = function* (data) {
  sessionStorage.setItem("rmp_token", data.rmp_token);
  const cookies = new Cookies();
  cookies.set("rmp_token", data.rmp_token, { path: "/" });

  const lang = data.lang || "th";
  sessionStorage.setItem("lang", lang);
  moment.locale(lang);
  if (data.ads) {
    const g_ads = data.ads.filter((item) => item.type === "g_ads");
    if (g_ads.length > 0) {
      yield call(setAd, { ad: g_ads[0], managedService: data.managedService });
    } else {
      yield call(setAd, { ad: data.ads[0], managedService: data.managedService });
    }
  }
};

export default {
  AuthAdpro: function* (data) {
    const __name = constants.AUTH_ADPRO;
    console.log("AuthAdpro data", data);
    if (data.otp) {
      const authOTPResult = yield call(AuthWithRMPOtp, { otp: data.otp });
      console.log("authOTPResult", authOTPResult);
      if (authOTPResult.res && (!authOTPResult.res.data.result || authOTPResult.res.data.result === 1)) {
        yield put({ type: `FETCH_SUCCESS_${__name}`, ...authOTPResult.res.data });
        yield call(setupAuthData, {
          ads: _get(authOTPResult, ["res", "data", "data", "ads"]),
          lang: _get(authOTPResult, ["res", "data", "data", "lang"]),
          managedService: _get(authOTPResult, ["res", "data", "data", "adwords_managed_service"]),
          rmp_token: _get(authOTPResult, ["res", "data", "data", "jwt"]),
        });
      } else {
        const authTokenResult = yield call(AuthWithRMPToken, { token: data.token });
        if (_get(authTokenResult, ["res", "data"])) {
          yield put({ type: `FETCH_SUCCESS_${__name}`, ...authTokenResult.res.data });
          yield call(setupAuthData, {
            ads: _get(authTokenResult, ["res", "data", "data", "ads"]),
            lang: _get(authTokenResult, ["res", "data", "data", "lang"]),
            managedService: _get(authTokenResult, ["res", "data", "data", "adwords_managed_service"]),
            rmp_token: data.token,
          });
        } else {
          authTokenResult.err.result = 6;
          yield put({ type: `FETCH_FAILURE_${__name}`, ...authTokenResult.err });
        }
      }
    } else {
      const authTokenResult = yield call(AuthWithRMPToken, { token: data.token });
      if (_get(authTokenResult, ["res", "data"])) {
        yield put({ type: `FETCH_SUCCESS_${__name}`, ...authTokenResult.res.data });
        yield call(setupAuthData, {
          ads: _get(authTokenResult, ["res", "data", "data", "ads"]),
          lang: _get(authTokenResult, ["res", "data", "data", "lang"]),
          managedService: _get(authTokenResult, ["res", "data", "data", "adwords_managed_service"]),
          rmp_token: data.token,
        });
      } else {
        authTokenResult.err.result = 6;
        yield put({ type: `FETCH_FAILURE_${__name}`, ...authTokenResult.err });
      }
    }
  },
  SetAd: function* (data) {
    yield call(setAd, { ad: data.ad });
  },
  SetFacebookAd: function* (data) {
    yield call(setFacebookAd, { ad: data.ad });
  },
  SendAnalyticsPageView: function* (data) {
    try {
      const res = yield call(
        Api.sendAnalyticsPageView,
        data.rmpBusinessId,
        data.adsAccountId,
        data.adsAccountName,
        data.page,
      );
      console.log("SendAnalyticsPageView", res);
    } catch (err) {
      console.log(err);
    }
  },
  SendAnalyticsLogin: function* (data) {
    try {
      const res = yield call(
        Api.sendAnalyticsLogin,
        data.rmpBusinessId,
        data.adsAccountId,
        data.adsAccountName,
        data.rAdproCreateTime,
      );
      console.log("SendAnalyticsLogin", res);
    } catch (err) {
      console.log(err);
    }
  },
  currentDashboard: function* (data) {
    const __name = constants.CURRENT_DASHBOARD;

    try {
      yield put({ type: `FETCH_SUCCESS_${__name}`, data });
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
    }
  },
  loginToRdynamic: function* (data) {
    const __name = constants.SET_FACEBOOK_CONVERSION_SETTING_STATUS;
    try {
      console.log("loginToRdynamic Data: ", data);
      const res = yield call(Api.loginToRdynamic, data.payload);
      console.log("loginToRdynamic Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  checkAppAvailable: function* (data) {
    const __name = constants.CHECK_APP_AVAILABLE;
    try {
      console.log("checkAppAvailable Data: ", data);
      const res = yield call(Api.checkAppAvailable, data.payload);
      console.log("checkAppAvailable Response: ", res);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
  /**
   * call getNexusUserInfo api
   * @param {*} data
   */
  getNexusUserInfo: function* (data) {
    const __name = constants.GET_NEXUS_USER_INFO;
    try {
      const res = yield call(Api.getNexusUserInfo, data.payload);
      yield put({ type: `FETCH_SUCCESS_${__name}`, ...res.data });
      yield call(resolvePromiseAction, data, res.data);
    } catch (err) {
      console.log(err);
      yield put({ type: `FETCH_FAILURE_${__name}`, err });
      yield call(rejectPromiseAction, data, err);
    }
  },
};
